import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFooter } from "./FooterContext";

export default function Footer({ debugging }) {
  const { message, clearMessage } = useFooter();

  if (!message) return null;

  // If debugging is off and the message is NOT an error, hide it
  if (!debugging && message.type !== "error") {
    return null;
  }

  const colorMap = {
    info: "#4e4e50ff",
    warning: "#ff9800",
    error: "#f44336"
  };
  const bg = colorMap[message.type] || colorMap.info;

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: bg,
        color: "#fff",
        px: 2,
        py: 1,
        position: "fixed",
        bottom: 0,
        left: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        gap: 1
      }}
    >
      <Box sx={{ flex: 1, textAlign: "center" }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {message.title}
        </Typography>
        {message.description && (
          <Typography
            variant="body2"
            sx={{ mt: 0.25, whiteSpace: "pre-line", opacity: 0.95 }}
          >
            {message.description}
          </Typography>
        )}
      </Box>

      <IconButton
        aria-label="Close notification"
        size="small"
        onClick={clearMessage}
        sx={{ color: "inherit" }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
}
